/**
 * @generated SignedSource<<05f533720ae263c9d8850690f125ee55>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DuplicateModelResultStatus = "ERROR" | "SUCCESS" | "WARNING";
export type ModelDuplicateTargetInput = {
  imageUrl?: string | null;
  name: string;
  salesChannelId: string;
  sku: string;
};
export type testPageDuplicateMutation$variables = {
  id: string;
  targets: ReadonlyArray<ModelDuplicateTargetInput>;
};
export type testPageDuplicateMutation$data = {
  readonly duplicateModel: {
    readonly productIDs: ReadonlyArray<number> | null;
    readonly resultMessage: string | null;
    readonly status: DuplicateModelResultStatus;
  };
};
export type testPageDuplicateMutation = {
  response: testPageDuplicateMutation$data;
  variables: testPageDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targets"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "targets",
        "variableName": "targets"
      }
    ],
    "concreteType": "DuplicateModelResult",
    "kind": "LinkedField",
    "name": "duplicateModel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productIDs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resultMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "testPageDuplicateMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "testPageDuplicateMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "9d6b451a8a6ccf95d80c45373a32850b",
    "id": null,
    "metadata": {},
    "name": "testPageDuplicateMutation",
    "operationKind": "mutation",
    "text": "mutation testPageDuplicateMutation(\n  $id: ID!\n  $targets: [ModelDuplicateTargetInput!]!\n) {\n  duplicateModel(id: $id, targets: $targets) {\n    productIDs\n    resultMessage\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "17dc6971e545ff4894e290322fc915c9";

export default node;
